/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type MarketResolved = {
  market: Address;
  oracle: Address;
  winnerMint: Address;
  claimableSupply: bigint;
  totalPot: bigint;
};

export type MarketResolvedArgs = {
  market: Address;
  oracle: Address;
  winnerMint: Address;
  claimableSupply: number | bigint;
  totalPot: number | bigint;
};

export function getMarketResolvedEncoder(): FixedSizeEncoder<MarketResolvedArgs> {
  return getStructEncoder([
    ['market', getAddressEncoder()],
    ['oracle', getAddressEncoder()],
    ['winnerMint', getAddressEncoder()],
    ['claimableSupply', getU64Encoder()],
    ['totalPot', getU64Encoder()],
  ]);
}

export function getMarketResolvedDecoder(): FixedSizeDecoder<MarketResolved> {
  return getStructDecoder([
    ['market', getAddressDecoder()],
    ['oracle', getAddressDecoder()],
    ['winnerMint', getAddressDecoder()],
    ['claimableSupply', getU64Decoder()],
    ['totalPot', getU64Decoder()],
  ]);
}

export function getMarketResolvedCodec(): FixedSizeCodec<
  MarketResolvedArgs,
  MarketResolved
> {
  return combineCodec(getMarketResolvedEncoder(), getMarketResolvedDecoder());
}
